// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; // If using proxy
export const COMPANIES_URL = '/api/companies';
export const ACTIVITIES_URL = '/api/activities';
export const USERS_URL = '/api/users';
export const CUSTOMERS_URL = '/api/customers';
export const CUSTOMERAUTH_URL = '/api/customersauths';
export const CUSTOMERSERVICE_URL = '/api/customerservices';
export const CUSTOMERPORTAL_URL = '/api/customerportals';
export const INVOICES_URL = '/api/invoices';
export const JOBS_URL = '/api/jobs';
export const SERVICEREQUESTS_URL = '/api/serviceRequests';
export const TECHNICIANS_URL = '/api/technicians';
export const AREAS_URL = '/api/areas';
export const CITIES_URL = '/api/cities';
export const NOTIFICATIONS_URL = '/api/notifications';
export const ITEMS_URL = '/api/items';
export const SUBSCRIPTION_URL = '/api/subscriptions';
export const BILLING_URL = '/api/billing';
export const BILLINGDASHBOARD_URL = '/api/dasboardbilling';
export const COMPANYBILLING_URL = '/api/companybilling';
